export const fetchGuideWithAuth = async (currentUser, url) => {
  if (!currentUser) {
    throw new Error('You must be logged in');
  }

  const token = await currentUser.getIdToken(true);
  const proxyUrl = `https://us-central1-guidesofia-access-control.cloudfunctions.net/fetchGuide?url=${encodeURIComponent(url)}`;

  const response = await fetch(proxyUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  return response;
};
